/* eslint-disable react/jsx-pascal-case */
import React from "react";
import { useSelector } from "react-redux";
import { deepCopy, toNumber, setNull } from "../../components/Common";
import BSL_Select from "../../components/BSL_Select";
import BSL_TextInput from "../../components/BSL_TextInput";
import * as BSL_Common from "../../components/BSL_CommonControls";
import { Grid, IconButton, LinearProgress } from "@material-ui/core";
import { checkJobStateValidationSchema } from "../../redux_store/jobState";
import DeleteIcon from "@material-ui/icons/Delete";
import BSL_Dialog from "../../components/BSL_Dialog";
import SegmentedButtonGroup from "../../components/SegmentedButtonGroup";
import Message from "../../components/Message";
import BSL_UploadDocument from "../../components/BSL_Upload/BSL_UploadDocument";
import Select from "react-select";
import SortedBusinessList from "./BusinessList";
import { CustomStyles, useStyles } from "./BusinessStyles";
import {
    addMarkup,
    deleteMarkup,
    getAddress,
    setErrorState,
    updateMarkup,
    updateNewUserBusiness,
    updatePaymentStructure,
    updateDefaultQuoteNotes,
} from "./BusinessFunctions";
import {
    InitaliseBusiness,
    InitaliseLoad,
    validateProgressPaymentPercentages,
} from "../component_effects/BusinessEffect";
import FixedPriceKits from "./FixedPriceKits";
import PremiumFeatures from "./PremiumFeatures";
import { MAX_MARKUP } from "./BusinessFunctions";

export default function ManageBusiness(props) {
    const classes = useStyles();
    const [deleteKey, setDeleteKey] = React.useState(null);
    const [deleteName, setDeleteName] = React.useState(null);
    const [newMarkup, seNewMarkup] = React.useState("");
    const [loading, setLoading] = React.useState(true);
    const [showMessage, setShowMessage] = React.useState(false);
    const [intialise, setIntialise] = React.useState(false);
    const [businessList, setBusinessList] = React.useState([]);

    const validationSchema = useSelector((state) => state.config.validationSchema);
    const offerings = useSelector((state) => state.app.offerings);
    const BusinessDetails = deepCopy(props.BusinessDetails);
    const errorState = deepCopy(props.ErrorState);
    const customStyles = CustomStyles;
    const markups = BusinessDetails?.MarkupStructure?.Markups;
    const paymentStructure = BusinessDetails?.MarkupStructure?.PaymentStructure;
    const superAdmin = props?.user?.Role === 99;

    let sourcePage = props.sourcePage;
    let isBillingAddress = true;

    // Use Effects
    InitaliseLoad({ intialise, setBusinessList, setLoading, setIntialise });

    InitaliseBusiness({
        intialise,
        setNull,
        BusinessDetails,
        validationSchema,
        checkJobStateValidationSchema,
        setErrorState,
        props,
        setIntialise,
    });

    validateProgressPaymentPercentages({ disableSaveButton: props.setSaveButtonDisabled, paymentStructure });

    let customer_types = [];
    if (markups)
        for (let key in markups) {
            let item = markups[key];
            customer_types.push({ Key: key, Display: item?.DisplayName ? item.DisplayName : key });
        }

    let markup_rows = [];

    let input_style = { padding: "0px", margin: "1px" };

    for (let key in markups) {
        let markup = markups[key];
        markup_rows.push(
            <Grid key={key} container item xs={12} spacing={0} className={classes.row_style}>
                <Grid item xs={4}>
                    <div className={classes.row_header}>
                        <IconButton
                            aria-label="delete"
                            size="small"
                            onClick={() => {
                                setDeleteName(markup?.DisplayName ? markup?.DisplayName : key);
                                setDeleteKey(key);
                            }}
                        >
                            <DeleteIcon fontSize="inherit" />
                        </IconButton>
                        <BSL_TextInput
                            value={markup?.DisplayName ? markup?.DisplayName : key}
                            preValidate="alphaNumeric"
                            tight
                            style={input_style}
                            onBlur={(val) =>
                                updateMarkup({ key, param: "DisplayName", value: val, BusinessDetails, props })
                            }
                        />
                    </div>
                </Grid>
                <Grid item xs={2}>
                    <div className={classes.row_cell}>
                        <BSL_TextInput
                            value={markup.Material}
                            tight
                            min={0}
                            max={MAX_MARKUP}
                            endAdornment="%"
                            style={input_style}
                            onBlur={(val) =>
                                updateMarkup({ key, param: "Material", value: val, BusinessDetails, props })
                            }
                        />
                    </div>
                </Grid>
                <Grid item xs={2}>
                    <div className={classes.row_cell}>
                        {" "}
                        <BSL_TextInput
                            value={markup.Installation}
                            tight
                            min={0}
                            max={MAX_MARKUP}
                            endAdornment="%"
                            style={input_style}
                            onBlur={(val) =>
                                updateMarkup({ key, param: "Installation", value: val, BusinessDetails, props })
                            }
                        />{" "}
                    </div>
                </Grid>
                <Grid item xs={2}>
                    <div className={classes.row_cell}>
                        {" "}
                        <BSL_TextInput
                            value={markup.PackingAndDel}
                            tight
                            min={0}
                            max={MAX_MARKUP}
                            endAdornment="%"
                            style={input_style}
                            onBlur={(val) =>
                                updateMarkup({ key, param: "PackingAndDel", value: val, BusinessDetails, props })
                            }
                        />{" "}
                    </div>
                </Grid>
                <Grid item xs={2}>
                    <div className={classes.row_cell}>
                        {" "}
                        <BSL_TextInput
                            value={markup.Commission}
                            tight
                            min={0}
                            max={MAX_MARKUP}
                            endAdornment="%"
                            style={input_style}
                            onBlur={(val) =>
                                updateMarkup({ key, param: "Commission", value: val, BusinessDetails, props })
                            }
                        />{" "}
                    </div>
                </Grid>
            </Grid>
        );
    }

    let businessesSorted = SortedBusinessList({ businessList, offerings });

    const updateOffer = (selectedOptions) => {
        const selected = selectedOptions.map((option) => {
            return { value: option.value, label: option.label, poa: option.poa, state: option.state };
        });

        // Check if Offer exists within BusinessDetails, if not, create an empty Offer object
        const newOffer = BusinessDetails.Offer ? { ...BusinessDetails.Offer } : {};

        // Update LinkedBusiness within the Offer object
        newOffer.LinkedBusiness = selected;

        // Update the LinkedBusiness property within the Offer object
        updateNewUserBusiness("Offer")("", newOffer, {
            BusinessDetails,
            props,
            validationSchema,
            checkJobStateValidationSchema,
            errorState,
        });

        // UPDATE Regions
        const regions = [
            ...new Set(
                businessesSorted
                    .filter((e) => selected.some((sel) => sel.value === e.Key)) // Use some() instead of includes() to compare objects properly
                    .map((business) => business.POA)
                    .concat(BusinessDetails.POA)
            ),
        ].filter((region) => region !== undefined && region !== null && region !== "undefined");

        // Update the Regions property within the Offer object
        const updatedOffer = {
            ...newOffer,
            Regions: regions,
        };

        // Update the Offer object with the updated Regions property
        updateNewUserBusiness("Offer")("", updatedOffer, {
            BusinessDetails,
            props,
            validationSchema,
            checkJobStateValidationSchema,
            errorState,
        });
    };

    return (
        <div className={classes.root} style={props.style}>
            <BSL_Common.SectionContainer>
                <BSL_Common.SectionHeader>Settings for {BusinessDetails.Name} (all users)</BSL_Common.SectionHeader>
                {props.admin && (
                    <>
                        <BSL_Common.SectionContainer>
                            <BSL_Common.SectionRow>
                                <SegmentedButtonGroup
                                    tight
                                    label="Status"
                                    ButtonGroupStyle={{
                                        flexWrap: "wrap",
                                    }}
                                    style={{ flex: "none" }}
                                    value={BusinessDetails?.Status}
                                    items={
                                        BusinessDetails?.Status === "ARCHIVED"
                                            ? ["ARCHIVED"]
                                            : ["NEW", "ACTIVE", "DEACTIVATED"]
                                    }
                                    onChange={(e, value) =>
                                        updateNewUserBusiness("Status")(e, value, {
                                            BusinessDetails,
                                            props,
                                            validationSchema,
                                            checkJobStateValidationSchema,
                                            errorState,
                                        })
                                    }
                                />
                                <SegmentedButtonGroup
                                    tight
                                    label="Business Type"
                                    ButtonGroupStyle={{
                                        flexWrap: "wrap",
                                    }}
                                    style={{ flex: "none" }}
                                    value={BusinessDetails?.Type ? BusinessDetails?.Type : "Customer"}
                                    items={["BBC", "Engineer", "Customer"]}
                                    onChange={(e, val) =>
                                        updateNewUserBusiness("Type")(e, val, {
                                            BusinessDetails,
                                            props,
                                            validationSchema,
                                            checkJobStateValidationSchema,
                                            errorState,
                                        })
                                    }
                                />
                                <SegmentedButtonGroup
                                    tight
                                    label="Quote WIth Failed Engineering"
                                    ButtonGroupStyle={{
                                        flexWrap: "wrap",
                                    }}
                                    style={{ flex: "1" }}
                                    value={
                                        BusinessDetails?.EngineerOverride ? BusinessDetails?.EngineerOverride : "ADMIN"
                                    }
                                    items={["ADMIN", "ALL USERS"]}
                                    onChange={(e, val) =>
                                        updateNewUserBusiness("EngineerOverride")(e, val, {
                                            BusinessDetails,
                                            props,
                                            validationSchema,
                                            checkJobStateValidationSchema,
                                            errorState,
                                        })
                                    }
                                />
                            </BSL_Common.SectionRow>
                            <BSL_Common.SectionRow>
                                <BSL_Common.SectionHeader>Linked Offering to Business License</BSL_Common.SectionHeader>
                            </BSL_Common.SectionRow>

                            <BSL_Common.SectionRow style={{ fontSize: "medium" }}>
                                {loading ? (
                                    <LinearProgress />
                                ) : (
                                    <Select
                                        isMulti
                                        id="CdsDropdown"
                                        options={businessesSorted.map((business) => ({
                                            value: business.Key,
                                            label: business.Display,
                                            poa: business.POA,
                                            state: business.State,
                                        }))}
                                        value={BusinessDetails?.Offer?.LinkedBusiness?.map((selected) => ({
                                            value: selected.value,
                                            label: selected.label,
                                            poa: selected.poa,
                                            state: selected.state,
                                        }))}
                                        onChange={(selectedOptions) => {
                                            updateOffer(selectedOptions);
                                        }}
                                        styles={customStyles}
                                    />
                                )}
                            </BSL_Common.SectionRow>
                            <BSL_Common.SectionRow>
                                <BSL_TextInput
                                    label="ID"
                                    preValidate="alpha"
                                    allCaps
                                    tight
                                    disabled={!(errorState?.id || BusinessDetails?.Status === "NEW")}
                                    max={3}
                                    value={BusinessDetails.id}
                                    onBlur={(e, val) =>
                                        updateNewUserBusiness("id")(e, val, {
                                            BusinessDetails,
                                            props,
                                            validationSchema,
                                            checkJobStateValidationSchema,
                                            errorState,
                                        })
                                    }
                                    error={errorState?.id}
                                    style={{ flex: 1 }}
                                    helperText={"*changing is NOT recommended"}
                                />
                                <BSL_TextInput
                                    label="Business Name"
                                    preValidate="name"
                                    tight
                                    disabled
                                    value={BusinessDetails.Name}
                                    onBlur={(e, val) =>
                                        updateNewUserBusiness("Name")(e, val, {
                                            BusinessDetails,
                                            props,
                                            validationSchema,
                                            checkJobStateValidationSchema,
                                            errorState,
                                        })
                                    }
                                    style={{ flex: 5 }}
                                    helperText={"*sync with Salesforce"}
                                />
                                <BSL_TextInput
                                    label="LYVES Account"
                                    preValidate="name"
                                    tight
                                    disabled={!(errorState?.LYVESAccount || BusinessDetails?.Status === "NEW")}
                                    value={BusinessDetails.LYVESAccount}
                                    onBlur={(e, val) =>
                                        updateNewUserBusiness("LYVESAccount")(e, val, {
                                            BusinessDetails,
                                            props,
                                            validationSchema,
                                            checkJobStateValidationSchema,
                                            errorState,
                                        })
                                    }
                                    style={{ flex: 2 }}
                                    helperText={"*sync with Salesforce"}
                                />
                            </BSL_Common.SectionRow>
                            <BSL_Common.SectionRow>
                                <BSL_TextInput
                                    label="Delivery Fee"
                                    preValidate="numeric"
                                    tight
                                    min={0}
                                    max={999}
                                    startAdornment="$"
                                    endAdornment=".00"
                                    value={BusinessDetails.DeliveryFee}
                                    onBlur={(e, val) =>
                                        updateNewUserBusiness("DeliveryFee")(e, val, {
                                            BusinessDetails,
                                            props,
                                            validationSchema,
                                            checkJobStateValidationSchema,
                                            errorState,
                                        })
                                    }
                                    error={errorState?.DeliveryFee}
                                    style={{ flex: 1 }}
                                    InputProps={{
                                        style: {
                                            textAlign: "right",
                                        },
                                    }}
                                />
                                <BSL_TextInput
                                    label="Packing Fee"
                                    preValidate="numeric"
                                    tight
                                    min={0}
                                    max={999}
                                    startAdornment="$"
                                    endAdornment=".00"
                                    value={BusinessDetails.PackingFee}
                                    onBlur={(e, val) =>
                                        updateNewUserBusiness("PackingFee")(e, val, {
                                            BusinessDetails,
                                            props,
                                            validationSchema,
                                            checkJobStateValidationSchema,
                                            errorState,
                                        })
                                    }
                                    error={errorState?.PackingFee}
                                    style={{ flex: 1 }}
                                    InputProps={{
                                        style: {
                                            textAlign: "right",
                                        },
                                    }}
                                />
                                <BSL_Select
                                    label="Dist Level"
                                    value={BusinessDetails.DistLevel}
                                    items={[
                                        "Retail",
                                        "Trade",
                                        "Dist 3",
                                        "Dist 2",
                                        "Dist 1.5",
                                        "Dist 1",
                                        "Dist 0.5",
                                        "Dist 0.25",
                                        "Dist 0.125",
                                        "Dist 0",
                                        "Cost",
                                    ]}
                                    tight={true}
                                    onChange={(e) => {
                                        let newBusinessDetails = deepCopy(BusinessDetails);
                                        newBusinessDetails.DistLevel = e.target.value;
                                        if (props.UpdateBusiness) props.UpdateBusiness(newBusinessDetails);
                                    }}
                                />
                            </BSL_Common.SectionRow>
                        </BSL_Common.SectionContainer>
                    </>
                )}
                <BSL_Common.SectionRow>
                    <BSL_UploadDocument
                        buttonText="IMPORT LOGO..."
                        backgroundText="UPLOAD A LOGO"
                        onSuccess={(message) => {
                            updateNewUserBusiness("Logo")(null, message.filename, {
                                BusinessDetails,
                                props,
                                validationSchema,
                                checkJobStateValidationSchema,
                                errorState,
                            });
                            setShowMessage(message);
                        }}
                        onError={setShowMessage}
                        onClear={() => {
                            updateNewUserBusiness("Logo")(null, "", {
                                BusinessDetails,
                                props,
                                validationSchema,
                                checkJobStateValidationSchema,
                                errorState,
                            });
                        }}
                        documentFolder={"BUS_" + BusinessDetails.Code}
                        documentFilename={BusinessDetails.Logo ? BusinessDetails.Logo : "logo"}
                        documentType="logo"
                        sizeLimitMB={1}
                    />
                </BSL_Common.SectionRow>
                <BSL_Common.SectionRow>
                    <BSL_TextInput
                        label="ABN"
                        preValidate="alphaNumeric"
                        tight
                        value={BusinessDetails.ABN}
                        onBlur={(e, val) =>
                            updateNewUserBusiness("ABN")(e, val, {
                                BusinessDetails,
                                props,
                                validationSchema,
                                checkJobStateValidationSchema,
                                errorState,
                            })
                        }
                        error={errorState?.ABN}
                    />
                    <BSL_TextInput
                        label="Building Licence"
                        tight
                        value={BusinessDetails.BuildingLicence}
                        onBlur={(e, val) =>
                            updateNewUserBusiness("BuildingLicence")(e, val, {
                                BusinessDetails,
                                props,
                                validationSchema,
                                checkJobStateValidationSchema,
                                errorState,
                            })
                        }
                        error={errorState?.BuildingLicence}
                    />
                </BSL_Common.SectionRow>
                <BSL_Common.SectionRow>
                    <BSL_TextInput
                        label="Business Email"
                        tight
                        disabled
                        value={BusinessDetails.Email}
                        onBlur={(e, val) =>
                            updateNewUserBusiness("Email")(e, val, {
                                BusinessDetails,
                                props,
                                validationSchema,
                                checkJobStateValidationSchema,
                                errorState,
                            })
                        }
                        helperText={"*sync with Salesforce"}
                    />
                    <BSL_TextInput
                        label="Business Phone"
                        tight
                        disabled
                        value={BusinessDetails.Phone}
                        onBlur={(e, val) =>
                            updateNewUserBusiness("Phone")(e, val, {
                                BusinessDetails,
                                props,
                                validationSchema,
                                checkJobStateValidationSchema,
                                errorState,
                            })
                        }
                        helperText={"*sync with Salesforce"}
                    />
                </BSL_Common.SectionRow>
                {sourcePage === "ManageUser" && (
                    <>
                        <BSL_Common.ElementHeader tight>Address for Quotes</BSL_Common.ElementHeader>
                        <BSL_Common.ElementHeader tight>Billing Address</BSL_Common.ElementHeader>
                        <BSL_Common.SectionRow>
                            <BSL_TextInput
                                label="Street"
                                tight
                                disabled
                                value={BusinessDetails.SalesForceData.Account.BillingAddress.street}
                            />
                            <BSL_TextInput
                                label="City"
                                tight
                                disabled
                                value={BusinessDetails.SalesForceData.Account.BillingAddress.city}
                            />
                        </BSL_Common.SectionRow>
                        <BSL_Common.SectionRow>
                            <BSL_TextInput
                                label="State"
                                tight
                                disabled
                                value={BusinessDetails.SalesForceData.Account.BillingAddress.state}
                            />
                            <BSL_TextInput
                                label="Postal Code"
                                tight
                                disabled
                                value={BusinessDetails.SalesForceData.Account.BillingAddress.postalCode}
                            />
                        </BSL_Common.SectionRow>
                        <BSL_Common.ElementHeader tight>Shipping Address</BSL_Common.ElementHeader>
                        <BSL_Common.SectionRow>
                            <BSL_TextInput
                                label="Street"
                                tight
                                disabled
                                value={BusinessDetails.SalesForceData.Account.ShippingAddress.street}
                            />
                            <BSL_TextInput
                                label="City"
                                tight
                                disabled
                                value={BusinessDetails.SalesForceData.Account.ShippingAddress.city}
                            />
                        </BSL_Common.SectionRow>
                        <BSL_Common.SectionRow>
                            <BSL_TextInput
                                label="State"
                                tight
                                disabled
                                value={BusinessDetails.SalesForceData.Account.ShippingAddress.state}
                            />
                            <BSL_TextInput
                                label="Postal Code"
                                tight
                                disabled
                                value={BusinessDetails.SalesForceData.Account.ShippingAddress.postalCode}
                            />
                        </BSL_Common.SectionRow>
                        <BSL_Common.SectionRow>
                            {getAddress({ BusinessDetails, isBillingAddress, props })}
                        </BSL_Common.SectionRow>
                    </>
                )}
                {props.admin && (
                    <>
                        <BSL_Common.SectionRow>
                            <BSL_Common.SectionHeader>Fixed Price Kits</BSL_Common.SectionHeader>
                        </BSL_Common.SectionRow>
                        <BSL_Common.SectionRow>
                            <FixedPriceKits business={BusinessDetails} updateBusiness={props.UpdateBusiness} />
                        </BSL_Common.SectionRow>
                    </>
                )}
                <BSL_Common.SectionHeader>Business Defaults</BSL_Common.SectionHeader>
                <BSL_Common.ElementHeader tight>Markups</BSL_Common.ElementHeader>
                <div style={{ padding: "10px" }}>
                    <Grid container spacing={1}>
                        <Grid container item xs={12} spacing={0}>
                            <Grid item xs={4}>
                                <div
                                    className={classes.col_header}
                                    style={{
                                        borderTopLeftRadius: "4px",
                                    }}
                                >
                                    {" "}
                                    Name{" "}
                                </div>
                            </Grid>
                            <Grid item xs={2}>
                                <div className={classes.col_header}> Material </div>
                            </Grid>
                            <Grid item xs={2}>
                                <div className={classes.col_header}> Installation </div>
                            </Grid>
                            <Grid item xs={2}>
                                <div className={classes.col_header}> Pack & Del </div>
                            </Grid>
                            <Grid item xs={2}>
                                <div
                                    className={classes.col_header}
                                    style={{
                                        borderTopRightRadius: "4px",
                                    }}
                                >
                                    {" "}
                                    Commission{" "}
                                </div>
                            </Grid>
                        </Grid>
                        {markup_rows}

                        <Grid container item xs={12} spacing={0}>
                            <Grid item xs={4}>
                                <div
                                    className={classes.row_header}
                                    style={{
                                        marginLeft: "24px",
                                    }}
                                >
                                    <BSL_TextInput
                                        placeholder="new markup"
                                        value={newMarkup}
                                        tight
                                        style={input_style}
                                        onBlur={(val) => addMarkup({ key: val, props, seNewMarkup, BusinessDetails })}
                                    />
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>
                </div>
                <BSL_Select
                    label="Default Markup"
                    tight
                    value={BusinessDetails.MarkupStructure.MarkupDefault}
                    items={customer_types}
                    onChange={(e) => {
                        let newBusinessDetails = deepCopy(BusinessDetails);
                        const defaultMarkup = e.target.value;

                        newBusinessDetails.MarkupStructure.MarkupDefault = defaultMarkup;

                        // Reorder Markups to make the default the first key
                        const markups = newBusinessDetails.MarkupStructure.Markups;
                        const reorderedMarkups = {
                            [defaultMarkup]: markups[defaultMarkup], // Add the default first
                            ...Object.keys(markups)
                                .filter((key) => key !== defaultMarkup) // Add the remaining keys
                                .reduce((obj, key) => {
                                    obj[key] = markups[key];
                                    return obj;
                                }, {}),
                        };

                        newBusinessDetails.MarkupStructure.Markups = reorderedMarkups;

                        if (props.UpdateBusiness) props.UpdateBusiness(newBusinessDetails);
                    }}
                    helperText={
                        "only applies to new jobs. If you want to change the markup on a current job, edit in the jobs 'edit details' page."
                    }
                />
                <BSL_Common.ElementHeader tight>Progress Payment Default %</BSL_Common.ElementHeader>
                <div style={{ padding: "10px" }}>
                    <Grid container spacing={1}>
                        <Grid container item xs={12} spacing={0} style={{ display: "flex", flexWrap: "wrap" }}>
                            <Grid item style={{ flexBasis: "20%", maxWidth: "20%" }}>
                                <div
                                    className={classes.col_header}
                                    style={{
                                        borderTopLeftRadius: "4px",
                                    }}
                                >
                                    {" "}
                                    Deposit
                                    <br />
                                    &nbsp;{" "}
                                </div>
                            </Grid>
                            <Grid item style={{ flexBasis: "20%", maxWidth: "20%" }}>
                                <div className={classes.col_header}>
                                    {" "}
                                    Progress 1<br />
                                    &nbsp;{" "}
                                </div>
                            </Grid>
                            <Grid item style={{ flexBasis: "20%", maxWidth: "20%" }}>
                                <div className={classes.col_header}>
                                    {" "}
                                    Progress 2<br />
                                    &nbsp;{" "}
                                </div>
                            </Grid>
                            <Grid item style={{ flexBasis: "20%", maxWidth: "20%" }}>
                                <div className={classes.col_header}>
                                    {" "}
                                    Progress 3<br />
                                    &nbsp;{" "}
                                </div>
                            </Grid>
                            <Grid item style={{ flexBasis: "20%", maxWidth: "20%" }}>
                                <div
                                    className={classes.col_header}
                                    style={{
                                        borderTopRightRadius: "4px",
                                    }}
                                >
                                    {" "}
                                    Final
                                    <br />
                                    &nbsp;{" "}
                                </div>
                            </Grid>
                        </Grid>

                        <Grid
                            container
                            item
                            xs={12}
                            spacing={0}
                            className={classes.row_style}
                            style={{ display: "flex", flexWrap: "wrap" }}
                        >
                            <Grid item style={{ flexBasis: "20%", maxWidth: "20%" }}>
                                <div className={classes.row_cell}>
                                    <BSL_TextInput
                                        value={toNumber(paymentStructure?.Deposit || 0)}
                                        tight
                                        min={0}
                                        max={100}
                                        endAdornment="%"
                                        style={input_style}
                                        onBlur={(value) =>
                                            updatePaymentStructure({ param: "Deposit", value, BusinessDetails, props })
                                        }
                                    />
                                </div>
                            </Grid>
                            <Grid item style={{ flexBasis: "20%", maxWidth: "20%" }}>
                                <div className={classes.row_cell}>
                                    {" "}
                                    <BSL_TextInput
                                        value={toNumber(paymentStructure?.Progress1 || 0)}
                                        tight
                                        min={0}
                                        max={100}
                                        endAdornment="%"
                                        style={input_style}
                                        onBlur={(value) =>
                                            updatePaymentStructure({
                                                param: "Progress1",
                                                value,
                                                BusinessDetails,
                                                props,
                                            })
                                        }
                                    />{" "}
                                </div>
                            </Grid>
                            <Grid item style={{ flexBasis: "20%", maxWidth: "20%" }}>
                                <div className={classes.row_cell}>
                                    {" "}
                                    <BSL_TextInput
                                        value={toNumber(paymentStructure?.Progress2 || 0)}
                                        tight
                                        min={0}
                                        max={100}
                                        endAdornment="%"
                                        style={input_style}
                                        onBlur={(value) =>
                                            updatePaymentStructure({
                                                param: "Progress2",
                                                value,
                                                BusinessDetails,
                                                props,
                                            })
                                        }
                                    />{" "}
                                </div>
                            </Grid>
                            <Grid item style={{ flexBasis: "20%", maxWidth: "20%" }}>
                                <div className={classes.row_cell}>
                                    {" "}
                                    <BSL_TextInput
                                        value={toNumber(paymentStructure?.Progress3 || 0)}
                                        tight
                                        min={0}
                                        max={100}
                                        endAdornment="%"
                                        style={input_style}
                                        onBlur={(value) =>
                                            updatePaymentStructure({
                                                param: "Progress3",
                                                value,
                                                BusinessDetails,
                                                props,
                                            })
                                        }
                                    />{" "}
                                </div>
                            </Grid>
                            <Grid item style={{ flexBasis: "20%", maxWidth: "20%" }}>
                                <div className={classes.row_cell_finalPP}>{paymentStructure?.SupplyOnlyDeposit}%</div>
                            </Grid>
                        </Grid>
                    </Grid>
                </div>
                <BSL_Common.ElementHeader tight>Default Quote Notes</BSL_Common.ElementHeader>
                <BSL_Common.SectionRow>
                    <BSL_TextInput
                        value={BusinessDetails?.DefaultQuoteNotes || ""}
                        multiline
                        tight
                        rows={5}
                        maxLength={350}
                        textFieldStyle={{ width: "100%" }}  
                        placeholder="Max 350 characters"
                        onBlur={(value) =>
                            updateDefaultQuoteNotes({
                                value,
                                BusinessDetails,
                                UpdateBusiness: props.UpdateBusiness,
                            })
                        }
                    />
                </BSL_Common.SectionRow>
                {superAdmin && (
                    <>
                        <BSL_Common.SectionRow>
                            <BSL_Common.SectionHeader>Premium Features</BSL_Common.SectionHeader>
                        </BSL_Common.SectionRow>

                        <BSL_Common.SectionRow>
                            <PremiumFeatures business={BusinessDetails} updateBusiness={props.UpdateBusiness} />
                        </BSL_Common.SectionRow>
                    </>
                )}
            </BSL_Common.SectionContainer>
            <BSL_Dialog
                title="Delete Markup?"
                open={deleteKey}
                onClose={() => setDeleteKey(null)}
                button1Text="Delete"
                button1Click={() =>
                    deleteMarkup({ key: deleteKey, BusinessDetails, setShowMessage, setDeleteKey, props })
                }
                button2Text="No"
                button2Click={() => setDeleteKey(null)}
            >
                <div style={{ display: "flex" }}>
                    <div>Are you sure you would like to delete this markup ({deleteName})?</div>
                </div>
            </BSL_Dialog>
            <Message
                open={showMessage}
                message={showMessage?.message}
                type={showMessage?.type}
                onClose={() => setShowMessage(null)}
            />
        </div>
    );
}
